import { render, staticRenderFns } from "./BvaHome.vue?vue&type=template&id=78501f2b&"
import script from "./BvaHome.vue?vue&type=script&lang=ts&"
export * from "./BvaHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports